import React, { PropsWithChildren } from 'react';
import { useHistory } from "react-router-dom";
import {IconButton} from "@fluentui/react";
import {useStyles} from "@v2/components/flowsteps/Flowstep/FlowstepEdit.styles";

interface TitledPageProps extends PropsWithChildren{
  title: string,
}

const TitledPage: React.FC<TitledPageProps> = ({ title, children}) => {

  const history = useHistory();
  const styles = useStyles();

  return (
    <div>
      <div className={styles.title}>
    <IconButton
      iconProps={{iconName: 'ChevronLeft'}}
  onClick={() => history.goBack()}
  />
  <span>{title}</span>
  </div>
      {children}
  </div>
)
}

export default TitledPage;
